export default __webpack_public_path__ + "media/images/avatars/avatar20-d8336d5af5d4978c1228b591eedf0502.png";